/**
 * Reducer and initial state only for the user related functionalities.
 */

import {
  USER_DETAILS_LOADING,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAILED,
  RESET_USER_DETAILS,
  PUNCH_DETAILS_SUCCESS,
  AUTH_DETAILS_LOADING,
  AUTH_DETAILS_SUCCESS,
  AUTH_DETAILS_FAILED,
  RESET_AUTH_DETAILS,
  RESET_ID_NOTIFICATION,
  SET_AUTH,
  IMT_ROLE_DETAILS_FAILED,
  IMT_ROLE_DETAILS_LOADING,
  IMT_ROLE_DETAILS_SUCCESS
} from "../CONSTANTS";

const user = {};
const googleUser = {};
const auth = {
  isAuthenticated: false, // user authentication
  isLoading: false,
  error: null,
  user,
  googleUser,
};

const initialState = {
  loading: false, // worker verification in progress
  user, // worker object to record new punch
  lastPunch: null, // last punch details of the worker verified to record new punch
  error: null, // worker verification error
  auth,
  idNotificationMsg: false,
  imtRole:{
    isLoading: true,
    error:null
  },
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_DETAILS_LOADING:
      return {
        ...state,
        error: null,
        user,
        lastPunch: null,
        loading: true,
        idNotificationMsg: false,
      };
    case AUTH_DETAILS_LOADING:
      return {
        ...state,
        auth:{
          ...state.auth,
          isLoading: true,
          error: null,
          user: { ...state.auth.user },
          googleUser
        }
      }
    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: action.payload,
        idNotificationMsg: false,
      };
    case AUTH_DETAILS_SUCCESS:
      return{
        ...state,
        auth:{
          ...state.auth,
          isLoading: false,
          error: null,
          user: action.payload.user,
          googleUser: action.payload.googleUser,
          isAuthenticated: true,
        }
      }
      case IMT_ROLE_DETAILS_SUCCESS:
        return{
          ...state,
          imtRole:{
            ...state.imtRole,
            isLoading: false,
            error: null,
            userRole: action.payload
          }
        }
        case IMT_ROLE_DETAILS_FAILED:
          return{
            ...state,
            imtRole:{
              ...state.imtRole,
              isLoading: false,
              error: action.payload,
              userRole: {}
            }
          }  
    case IMT_ROLE_DETAILS_LOADING:
      return {
              ...state,
              imtRole:{
                ...state.imtRole,
                isLoading: true,
                error: null,
                userRole: {}
              }
     }          
    case USER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        user,
        lastPunch: null,
        error: action.payload.err,
        idNotificationMsg: action.payload.notification,
      };
    case AUTH_DETAILS_FAILED:
      return {
        ...state,
        auth:{
          ...state.auth,
          isLoading: false,
          error: action.payload,
          user,
          googleUser,
          isAuthenticated: false,
        }
      }
    case RESET_USER_DETAILS:
      return {
        ...initialState,
        auth: {
          ...state.auth,
        },
      };
    case RESET_AUTH_DETAILS:
      return {
        ...state,
        auth: {
          ...state.auth,
          isAuthenticated: false,
          isLoading: false,
          user: { ...state.auth.user },
          googleUser,
        },
      };
    case PUNCH_DETAILS_SUCCESS:
      return {
        ...state,
        lastPunch: action.payload,
      };
    case SET_AUTH:
      state.auth = {
        ...state.auth,
        isAuthenticated: true,
        user: { ...state.auth.user, isManager: true, isApprover: true, isTemp: false },
      };
      return state;
    case RESET_ID_NOTIFICATION:
      return {
        ...state,
        error: null,
        idNotificationMsg: false,
      };
    default:
      return state;
  }
};
export default userReducer;
